import { render, staticRenderFns } from "./databaseManager.vue?vue&type=template&id=69b8761d&"
import script from "./databaseManager.vue?vue&type=script&lang=js&"
export * from "./databaseManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports